import colors from 'assets/variables/colors';

export const NEW_SKILL_COLOR = '#1C9DD7';
export const NEW_SKILL_BG = 'rgba(28, 157, 215, 0.12)';

export const getSkillChipSx = (isSaved: boolean) => ({
  backgroundColor: isSaved ? colors.lightPurple : NEW_SKILL_BG,
  borderRadius: '60px',
  height: '32px',
  color: isSaved ? colors.tenantColor : NEW_SKILL_COLOR,
  marginTop: '8px',
  border: isSaved ? undefined : `1px solid ${NEW_SKILL_COLOR}`
});
